import { render, staticRenderFns } from "./ERP_exchange_platform-modal.vue?vue&type=template&id=160675a4&scoped=true"
import script from "./ERP_exchange_platform-modal.vue?vue&type=script&lang=js"
export * from "./ERP_exchange_platform-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160675a4",
  null
  
)

export default component.exports